module.exports = __webpack_public_path__ + "img/cannaSuite_brand_shadow.fc0a40ad.svg";